"use client";

import { useFetchQuery } from "@/hooks/useFetchQuery";

/**
 * useAuth — Convenience hook that replaces useSession() from next-auth.
 *
 * Returns the current user profile from pms-api via GET /auth/my-profile.
 * Data is cached with Infinity staleTime (fetched once per session by AuthGuard).
 *
 * Usage:
 *   const { user, isLoading, isAuthenticated } = useAuth()
 */
export function useAuth() {
  const { data, isLoading, isError } = useFetchQuery("getMyProfile");

  const user = data?.data || null;

  return {
    user,
    isLoading,
    isAuthenticated: !!user && !isError,
    isError,
  };
}
